export const parser = (payload) => {
  let string = ''
  for (const key in payload?.params) {
    if (payload?.params[key]) {
      string += `&${key}=${payload?.params[key]}`
    }
  }
  return string
}
